import * as React from "react";
import { ConsentLinkSessionContext } from "../context/ConsentLinkSessionContext";

export default function useConsentLinkSession() {
    const value = React.useContext(ConsentLinkSessionContext);

    if (!value) {
        throw new Error(
            "useConsentLinkSession must be used inside ConsentLinkSessionProvider"
        );
    }

    return value;
}
